import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import fr from "vuetify/es5/locale/fr";

import "@mdi/font/css/materialdesignicons.css";

import "../sass/style.sass";
import "fontsource-raleway/400.css";
import "fontsource-raleway/400-italic.css";

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    themes: {
      light: {
        color_flash: "#73478e",
        color_navigation: "#280659",
        color_header: "#b9a3c6",
        color_loading: "#951cb7",
        color_action: "#35bdd3",

        color_card_title: "#b9a3c6",
        color_progress: "#d537fc",
        color_progress_end: "#cddc39",
        color_card: "#cfdade",
        color_breadcrumbs: "#1c36b7",
        color_thead: "#3F51B5",
        color_bordered: "#ececec",
        color_select: "#c05a3a",

        color_primary: "#1c36b7",
        color_danger: "#ed8792",
        color_warning: "#ff602b",
        color_success: "#5fab28",
      },
    },
  },
  lang: {
    locales: { fr },
    current: "fr",
  },
  icons: {
    iconfont: "mdi",
  },
});
